export const INITIAL_EXPAND_ACCORDION_COUNT = 3;
